import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Oval } from "react-loader-spinner"; // Import loader
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock, faEnvelope } from "@fortawesome/free-solid-svg-icons"; // Import icons

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false); // Add loading state

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true); // Set loading state to true when submission starts
    try {
      const response = await axios.post(
        "https://backend.inyumba.co.ke/iNyumba/auth/forgot-pwd",
        { email }
      );
      // Display success message using toast
      toast.success(response.data.response || "Password reset link sent to your email!");
      setIsLoading(false); // Set loading state to false after successful response
      // Redirect to the login page
      navigate("/");
    } catch (error) {
      // Display error message using toast
      const errorMessage = error.response?.data?.response || "An unexpected error occurred. Please try again.";
      toast.error(errorMessage);
      setIsLoading(false); // Set loading state to false on error
      console.error(error); // Log the error for debugging
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 p-4 sm:p-6 lg:p-8">
      <div className="max-w-md w-full bg-white rounded-xl shadow-2xl p-8 space-y-8 animate-fade-in">
        <div className="text-center">
          <FontAwesomeIcon icon={faLock} className="text-indigo-600 text-5xl mb-4" />
          <h2 className="text-4xl font-extrabold text-gray-900 mb-2">
            Forgot Password
          </h2>
          <p className="text-gray-600 text-lg">
            Enter your email to receive a password reset link.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="email" className="sr-only">
              Email Address
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <FontAwesomeIcon icon={faEnvelope} className="text-gray-400" />
              </div>
              <input
                id="email"
                type="email"
                value={email}
                onChange={handleChange}
                autoComplete="email"
                required
                className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-base transition-colors duration-200"
                placeholder="Email address"
              />
            </div>
          </div>

          <div>
            <button
              type="submit"
              disabled={isLoading}
              className={`w-full py-3 px-6 rounded-lg text-lg font-semibold transition-all duration-300 ease-in-out flex items-center justify-center space-x-3 shadow-md
                ${isLoading
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-indigo-600 text-white hover:bg-indigo-700 transform hover:scale-105"
                }`}
            >
              {isLoading ? (
                <>
                  <Oval
                    height={20}
                    width={20}
                    color="white"
                    ariaLabel="loading-spinner"
                    secondaryColor="rgba(255,255,255,0.4)"
                    strokeWidth={5}
                    strokeWidthSecondary={2}
                  />
                  <span>Sending Link...</span>
                </>
              ) : (
                <span>Send Reset Link</span>
              )}
            </button>
          </div>
        </form>

        <div className="text-center text-sm text-gray-600">
          Remembered your password?{" "}
          <button
            onClick={() => navigate("/")}
            className="font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200"
          >
            Log In
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;